import BundleProductList from './BundleProductList';

export default BundleProductList;
